var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Tile, TileContent, TileGroup, TileText, } from '@one-thd/sui-atomic-components';
import { params, shape, string as stringType, number as numberType, } from '@thd-nucleus/data-sources';
import { GridView, ListView } from '@one-thd/sui-icons';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { useLoyaltyMembershipDetails } from '../../../hooks/useDataSources';
import { pushEventInfo } from '../../../utils/analytics';
import { getWindow } from '../../../utils/general';
var initialTileData = [
    {
        value: 'Card',
        text: 'Card View',
        icon: React.createElement(GridView, { color: "current", size: "small" }),
    },
    {
        value: 'Table',
        text: 'Table View',
        icon: React.createElement(ListView, { color: "current", size: "small" }),
    },
];
export var OrderViewToggle = function () {
    var _a, _b;
    var _c = usePurchaseHistoryContext(), viewType = _c.viewType, setViewType = _c.setViewType;
    var _d = (_a = useLoyaltyMembershipDetails()) !== null && _a !== void 0 ? _a : {}, data = _d.data, loading = _d.loading;
    var _e = React.useState(initialTileData), tileData = _e[0], setTileData = _e[1];
    var containsLocalView = tileData.some(function (tile) { return tile.value === 'localView'; });
    var enableLocalDeliveryViewFS = FeatureSwitches.enableLocalDeliveryView;
    /**
     * Logic checks the proTiers benefitTags to see if the account is a managed account
     * Where tag.tagName includes the text 'AMBenefit' && tag.value === 'Confirmed'
     */
    var managedAccountCheck = function (proTiers) {
        if (proTiers === undefined)
            return false;
        return proTiers === null || proTiers === void 0 ? void 0 : proTiers.benefitTags.some(function (tag) { return tag.tagName.includes('AMBenefit') && tag.value === 'Confirmed'; });
    };
    useEffect(function () {
        var _a;
        if (!loading && data) {
            var isManagedAccount = managedAccountCheck((_a = data === null || data === void 0 ? void 0 : data.loyaltyMembershipDetails) === null || _a === void 0 ? void 0 : _a.proTiers);
            if (isManagedAccount && !containsLocalView && enableLocalDeliveryViewFS) {
                setTileData(function (prevTileData) { return __spreadArray(__spreadArray([], prevTileData, true), [
                    {
                        value: 'LocalDeliveries',
                        text: 'Local Deliveries View',
                        icon: React.createElement(ListView, { color: "current", size: "small" }),
                    },
                ], false); });
            }
        }
    }, [(_b = data === null || data === void 0 ? void 0 : data.loyaltyMembershipDetails) === null || _b === void 0 ? void 0 : _b.proTiers]);
    return (React.createElement("div", { className: "sui-mr-3", "data-testid": "orderViewToggle" },
        React.createElement(TileGroup, { onChange: function (_event, newViewType) {
                var _a;
                if (newViewType) {
                    setViewType(newViewType);
                    // LocalDeliveries should not be set in localStorage
                    if (newViewType !== 'LocalDeliveries') {
                        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.localStorage.setItem('viewType', newViewType);
                    }
                    pushEventInfo({
                        category: { primaryCategory: 'button submission' },
                        eventInfo: { eventName: 'my account settings' },
                        myAccount: {
                            settings: "purchase history: toggle: ".concat((function () {
                                if (newViewType === 'Card') {
                                    return 'card';
                                }
                                if (newViewType === 'Table') {
                                    return 'list';
                                }
                                if (newViewType === 'LocalDeliveries') {
                                    return 'local deliveries';
                                }
                                return '';
                            })(), " view"),
                        },
                    });
                }
            }, value: viewType, "aria-label": "View Options" }, tileData.map(function (item, key) { return (React.createElement(Tile, { key: key, value: item.value, "aria-label": item.text },
            React.createElement(TileContent, null,
                React.createElement("span", { className: classNames('sui-pt-1', {
                        'sui-text-brand': viewType === item.value,
                    }) }, item.icon),
                React.createElement(TileText, null, item.text)))); }))));
};
var proTiers = shape({
    benefitTags: shape({
        tagName: stringType(),
        value: stringType(),
    }),
});
OrderViewToggle.dataModel = {
    loyaltyMembershipDetails: params({
        channelId: numberType().isRequired(),
        customerAccountId: stringType().isRequired(),
        userId: stringType().isRequired(),
    }).shape({
        proTiers: proTiers,
    }),
};
